import gql from "graphql-tag";

export const SET_WEPA_BOOKING_FLAG = gql`
  mutation setWepaBookingFlag($bookingId: Int!, $flag: WepaBookingStatusFlag!, $companyId: ID!) {
    setWepaBookingFlag(bookingId: $bookingId, flag: $flag, companyId: $companyId) {
      feedback
    }
  }
`;
